var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6417 0.334634C10.8711 0.548964 11 0.83962 11 1.14268C11 1.44575 10.8711 1.7364 10.6417 1.95073L4.52204 7.66537C4.29252 7.87963 3.98127 8 3.65673 8C3.33219 8 3.02093 7.87963 2.79141 7.66537L0.343569 5.37951C0.120622 5.16395 -0.00274234 4.87525 4.62675e-05 4.57558C0.00283488 4.27591 0.131554 3.98924 0.358479 3.77734C0.585404 3.56543 0.892379 3.44523 1.21329 3.44262C1.5342 3.44002 1.84336 3.55522 2.0742 3.76341L3.65673 5.24122L8.91103 0.334634C9.14055 0.120368 9.4518 0 9.77634 0C10.1009 0 10.4121 0.120368 10.6417 0.334634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxCheck);
export default __webpack_public_path__ + "static/media/checkBox_check.61bc0dfb5954d41de477ed9324e1a59c.svg";
export { ForwardRef as ReactComponent };